import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';

import { ICountryMySuffix } from 'src/app/shared/model/country-my-suffix.model';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';

@Component({
    selector: 'jhi-country-my-suffix-detail',
    templateUrl: './country-my-suffix-detail.component.html'
})
export class CountryMySuffixDetailComponent implements OnInit {
    country: ICountryMySuffix;

    constructor(private activatedRoute: ActivatedRoute,
        private languageChangeService: LanguageChangeService
        ) {
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
    }

    ngOnInit() {
        this.activatedRoute.data.subscribe(({ country }) => {
            this.country = country;
        });
    }

    previousState() {
        window.history.back();
    }
}
